import "./TermsOfUse.module.css";
import Header from "@/reusable_sections/Header";
import HeroBackgroundOverlay from "./sections/HeroBackgroundOverlay";
import PreventativeMaintenance from "./sections/PreventativeMaintenance";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import OnaCharacter from "./sections/OnaCharacter";
import WhyChooseOmSteel from "./sections/WhyChooseOmSteel";
import Faq from "./sections/Faq";
import ContactMethodsGrid from "./sections/ContactMethodsGrid";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfUsePage() {
  return <div>
      <Header />
      <HeroBackgroundOverlay />
      <PreventativeMaintenance />
      <FrequentlyAskedQuestions />
      <OnaCharacter />
      <WhyChooseOmSteel />
      <Faq />
      <ContactMethodsGrid />
      <Footer />
    </div>;
}